module.exports = __webpack_public_path__ + "img/links-fill.49efb83b.svg";